import { createSlice } from "@reduxjs/toolkit"

export const reqAttributesListSlice = createSlice({
	name: "reqAttributes_list",
	initialState: {
		reqAttributes: "",
		errors: [],
	},

	reducers: {
        getReqAttributes: (state, action) => {
            // console.log(action.payload)
			state.reqAttributes = action.payload
		},
		getRegAttributesList: (state, action) => {
			state.reqAttributes = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getReqAttributes, getRegAttributesList, getErrors} = reqAttributesListSlice.actions

export default reqAttributesListSlice.reducer
